export const SystemSettingMap = {
  GET_ALL_SYSTEM_SETTING_START: "GET_ALL_SYSTEM_SETTING_START",
  GET_ALL_SYSTEM_SETTING_SUCCESS: "GET_ALL_SYSTEM_SETTING_SUCCESS",
  GET_ALL_SYSTEM_SETTING_ERROR: "GET_ALL_SYSTEM_SETTING_ERROR",
  SELECT_USER_DETAILS: "SELECT_USER_DETAILS",
  APPLY_FILTERS: "APPLY_FILTERS",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  REFRESH_SYSTEM_SETTING_LIST: "REFRESH_SYSTEM_SETTING_LIST",
  SET_SYSTEM_SETTING_BATCH_NUMBER: "SET_SYSTEM_SETTING_BATCH_NUMBER",
  SELECT_SYSTEM_SETTING_DETAILS: "SELECT_SYSTEM_SETTING_DETAILS",
  // GET_ALL_TEMPLATES_START: "GET_ALL_TEMPLATES_START",
  // GET_ALL_TEMPLATES_SUCCESS: "GET_ALL_TEMPLATES_SUCCESS",
  // GET_ALL_TEMPLATES_ERROR: "GET_ALL_TEMPLATES_ERROR",
  UPDATE_SYSTEM_SETTING_START: "UPDATE_SYSTEM_SETTING_START",
  UPDATE_SYSTEM_SETTING_SUCCESS: "UPDATE_SYSTEM_SETTING_SUCCESS",
  UPDATE_SYSTEM_SETTING_ERROR: "UPDATE_SYSTEM_SETTING_ERROR",
};

export const SystemSettingActions = {
  getAllSystemSettingStart: (data) => ({
    type: SystemSettingMap.GET_ALL_SYSTEM_SETTING_START,
    payload: data,
  }),
  getAllSystemSettingSuccess: (data) => ({
    type: SystemSettingMap.GET_ALL_SYSTEM_SETTING_SUCCESS,
    payload: data,
  }),
  getAllSystemSettingError: (errors) => ({
    type: SystemSettingMap.GET_ALL_SYSTEM_SETTING_ERROR,
    payload: { errors },
  }),

  updateSystemSettingStart: (data) => ({
    type: SystemSettingMap.UPDATE_SYSTEM_SETTING_START,
    payload: data,
  }),
  updateSystemSettingSuccess: (data) => ({
    type: SystemSettingMap.UPDATE_SYSTEM_SETTING_SUCCESS,
    payload: data,
    
  }),
  updateSystemSettingError: (errors) => ({
    type: SystemSettingMap.UPDATE_SYSTEM_SETTING_ERROR,
    payload: { errors },
  }),

  applyFilters: (data) => ({
    type: SystemSettingMap.APPLY_FILTERS,
    payload: data,
  }),
  refreshSystemSettingList: () => ({
    type: SystemSettingMap.REFRESH_SYSTEM_SETTING_LIST,
  }),
  searchTextChange: (data) => ({
    type: SystemSettingMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setSelectedSystemSetting: (data) => ({
    type: SystemSettingMap.SELECT_SYSTEM_SETTING_DETAILS,
    payload: data,
  }),
  setSystemSettingBatchNumber: (data) => ({
    type: SystemSettingMap.SET_SYSTEM_SETTING_BATCH_NUMBER,
    payload: data,
  }),
};
